import { render, staticRenderFns } from "./channelcallback-add-or-update.vue?vue&type=template&id=f2ec8bba&"
import script from "./channelcallback-add-or-update.vue?vue&type=script&lang=js&"
export * from "./channelcallback-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports